
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_dm8gx_1chob_97",
  "has-items": "awsui_has-items_dm8gx_1chob_109",
  "token": "awsui_token_dm8gx_1chob_113",
  "dismiss-button": "awsui_dismiss-button_dm8gx_1chob_125",
  "token-disabled": "awsui_token-disabled_dm8gx_1chob_159",
  "toggle": "awsui_toggle_dm8gx_1chob_174",
  "description": "awsui_description_dm8gx_1chob_237"
};
  